import { computed } from '@angular/core';
import { signalStore, withComputed, withMethods } from '@ngrx/signals';
import { withActivePet } from '../features/active-pet/active-pet.feature';
import { withTenant } from '../features/tenant/tenant.feature';
import { withUser } from '../features/user/user.feature';

export const PolicyStore = signalStore(
  withUser(),
  withActivePet(),
  withTenant(),
  withComputed(({ tenant, activePet }) => {
    return {
      insurer: computed(() => tenant()?.name || null),
      policyNumber: computed(() => activePet()?.policy_no || null),
      policyStartDate: computed(() => activePet()?.policy_start_date || null),
      policyRegisteredDate: computed(() => activePet()?.policy_registered_date || null),
      policyDisabledDate: computed(() => activePet()?.policy_disabled_date || null),
      policyActive: computed(() => activePet()?.policy_active || false),
    };
  }),
  withMethods((store) => {
    return {
      isActivePetInsured: () => {
        return store.policyActive() && store.insurer() !== null && store.insurer() !== '';
      },
    };
  })
);
